<template>
  <div class="packagelst">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav ref="userNav"></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="订单列表">
          <div class="content">
            <div class="filter-box noSelect">
              <div class="filter-item">
                <div class="filter-item-left">
                  <span class="filter-item-key">订单状态</span>
                  <el-select v-model="param.status" placeholder="请选择状态" style="margin-right: 10px;">
                    <el-option v-for="(item, index) in state_list" :key="index" :label="item" :value="index === 0 ? '' : index - 1"></el-option>
                  </el-select>
                </div>

                <div class="filter-item-right">
                  <span class="filter-item-key">导出类型</span>
                  <el-select v-model="param.mode" placeholder="请选择导出方式" style="margin-right: 10px;">
                    <el-option :value="''" label="全部" />
                    <el-option :value="0" label="手动输入" />
                    <el-option :value="1" label="模板导入" />
                    <el-option :value="2" label="自动发货" />
                  </el-select>
                  <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                </div>
              </div>
              <div class="filter-item">
                <div class="filter-item-left">
                  <el-input v-model="param.out_order_no" placeholder="订单号" style="margin-right: 20px;"></el-input>
                  <el-input v-model="param.express_no" placeholder="快递单号"></el-input>
                </div>

                <div class="filter-item-right">
                  <el-input v-model="param.order_no" placeholder="第三方单号"></el-input>

                  <div class="btn btn1" @click="submitForm">查询</div>
                  <div class="btn btn2" @click="resetForm">重置</div>
                </div>
              </div>
            </div>

            <div :style="`height:60px; background-image: url('${IMG_URL}images/fzappbg.png')`">
              <a href="https://www.163.com/dy/article/FK04CABM0517C6UQ.html" class="fzapp" target="blank">
                本站已与网警协同合作，一经发现退款诈骗等行为，立即上报，点击查看案件详情！您的IP：{{ ip }}，{{ city }}
              </a>
            </div>

            <div class="button-main">
              <el-button v-if="out_order_no" class="btn btn-style-2" size="mini" type="danger" @click="onSelectError">选中失败</el-button>
              <el-button v-if="out_order_no" class="btn btn-style-1" size="mini" type="primary" @click="onAddOrder">重新下单</el-button>
            </div>
            <el-table
              v-loading="loadingData"
              ref="multipleTable"
              :data="tableData"
              height="600px"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              tooltip-effect="dark"
              style="width: 100%"
              border
              @selection-change="handleSelectionChange"
            >
              <el-table-column fixed="left" type="selection" align="center" width="50" />
              <el-table-column label="数据源" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.source === 0 ? "淘宝/天猫" : scope.row.source === 1 ? "京东" : scope.row.source === 2 ? "拼多多" : "其他" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单状态" width="90">
                <template slot-scope="scope">
                  <el-button :type="scope.row.status !== 3 ? 'success' : 'danger'" size="mini" @click="onStatus(scope.row)">
                    {{ scope.row.status_name == "撤销订单" ? "已退款" : scope.row.status_name }}
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column prop="product_name" label="礼品" max-width="180" />
              <el-table-column prop="price" label="费用" width="50">
                <template slot-scope="scope">
                  <span class="onCopy">¥{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="express_company" label="快递信息" width="120">
                <template slot-scope="scope">
                  <div class="info-item">公司：{{ scope.row.express_company }}</div>
                  <div class="info-item">
                    单号：
                    <el-tooltip v-if="!scope.row.should_real_check || scope.row.should_real_check === 0" class="item" effect="dark" content="点击单号复制" placement="right">
                      <span v-clipboard:copy="scope.row.express_no" v-clipboard:success="onCopy" v-clipboard:error="onError" class="onCopy">{{ scope.row.express_no }}</span>
                    </el-tooltip>
                    <a v-else style="color: #FF0000;" href="javascript:void(0);" class="info-real" @click="onealCheck">【点击实名】需要实名认证才能查看快递单号</a>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="收货人信息" width="210">
                <template slot-scope="scope">
                  <div class="info-item">姓名：{{ scope.row.fullname }}</div>
                  <div class="info-item">电话：{{ scope.row.mobile }}</div>
                  <div class="info-item">地址：{{ scope.row.original }}</div>
                  <div class="info-item">
                    第三方单号：
                    <el-tooltip class="item" effect="dark" content="点击单号复制" placement="right">
                      <span v-clipboard:copy="scope.row.order_no" v-clipboard:success="onCopy" v-clipboard:error="onError" class="onCopy" title="">{{ scope.row.order_no }}</span>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="out_order_no" label="平台单号" width="130">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击单号复制" placement="right">
                    <div v-clipboard:copy="scope.row.out_order_no" v-clipboard:success="onCopy" v-clipboard:error="onError" class="onCopy" title="点击复制">{{ scope.row.out_order_no }}</div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!-- <el-table-column label="物流状态" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.logistics_data">{{ scope.row.logistics_data.wuliuzhuangtai }}</span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column prop="error_msg" label="错误信息" width="200">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="点击复制" placement="right">
                    <div v-clipboard:copy="scope.row.error_msg" v-clipboard:success="onCopy" v-clipboard:error="onError" class="onCopy">{{ scope.row.error_msg }}</div>
                  </el-tooltip>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="耗时" width="120">
                <template slot-scope="scope">
                  <div class="info-item">出单：{{ scope.row.issue_time | issueTime }}</div>
                  <div class="info-item">收揽：{{ scope.row.issue_time | issueTime }}</div>
                </template>
              </el-table-column> -->

              <el-table-column prop="createtime" label="交易时间" width="130" />
            </el-table>
            <div class="page-box">
              <el-pagination
                :page-size="param.limit"
                :total="totalCount"
                :page-sizes="[20, 50, 100, 200, 300, 400]"
                layout="prev, pager, next,total,sizes,jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import { apiOrderPacjAgeLst, apiGetRealQrcode, apiGeo } from "@/api/api";
import QRCode from "qrcodejs2";
export default {
  name: "packagelst",
  components: { headerNav, userNav, footerBox },
  filters: {
    issueTime(val) {
      var time = "-";
      if (val > 0 && val <= 60) {
        time = val + "秒";
      } else if (val > 60) {
        time = (val / 60).toFixed(2) + "分钟";
      }
      return time;
    },
  },
  data() {
    return {
      dialogVisible: false,
      radio2: "",
      navData: [
        { name: "今日", value: "today" },
        { name: "昨日", value: "yesterday" },
        {
          name: "近7日",
          value: "day7",
        },
        { name: "近30日", value: "day30" },
      ],
      state_list: ["全部", "任务处理中", "发货中", "已发货", "已退款"],

      date: "",
      param: {
        page: 1,
        limit: 20,
        mode: "",
        status: "",
        mobile: "",
        order_no: "",
        express_no: "",
        out_order_no: "",
      },
      tableData: [],
      totalCount: 0,
      loadingData: true,
      order_id: "",
      out_order_no: "",
      error_order_lst: [],
      tab_pane_active: 0,
      ip: "",
      city: "",
    };
  },
  mounted(e) {
    if (this.$route.query.out_order_no) {
      this.out_order_no = this.$route.query.out_order_no;
    }
    this.loadData();
    apiGeo().then(res => {
      let data = JSON.parse(res.data);
      this.ip = data["ip"];
      this.city = data["addr"];
    });
  },
  methods: {
    timeFilter13(time) {
      let date = new Date(Number(time));
      let y = date.getFullYear();
      let m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
      let d = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      let hh = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
      let mm = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
      let ss = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    handleClose() {},
    onealCheck() {
      this.$refs.userNav.onealCheck();
    },
    creatQrCode(url) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url, // 需要转换为二维码的内容
        width: 240,
        height: 240,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    handleSelectionChange(value) {
      // this.error_order_lst = value;
      for (var i = 0; i < value.length; i++) {
        if (value[i].status === 3) {
          var flag = 0;
          for (var j = 0; j < this.error_order_lst.length; j++) {
            if (this.error_order_lst[j] == value[i]) {
              flag = 1;
              break;
            }
          }
          if (flag == 0) {
            this.error_order_lst.push(value[i]);
          }
        }
      }
    },
    // 选中失败订单
    onSelectError() {
      var that = this;
      var rows = [];
      for (var i = 0; i < that.tableData.length; i++) {
        if (that.tableData[i].status === 3) {
          rows.push(that.tableData[i]);
        }
      }
      if (rows.length > 0) {
        rows.forEach(row => {
          that.$refs["multipleTable"].toggleRowSelection(row);
        });
      } else {
        this.$message.success("暂无失败订单");
      }
    },
    // 重新下单
    onAddOrder() {
      if (this.error_order_lst.length <= 0) {
        this.$message.info("请选中失败包裹");
        return false;
      }
      var convenient_order_add = {
        source: this.error_order_lst[0].source,
        mode: this.error_order_lst[0].mode,
        shop_id: 0,
        package: [],
      };
      if (this.error_order_lst[0].mode !== 2) {
        for (var i = 0; i < this.error_order_lst.length; i++) {
          convenient_order_add.package.push(
            this.error_order_lst[i].order_no +
              "," +
              this.error_order_lst[i].fullname +
              " " +
              this.error_order_lst[i].mobile +
              " " +
              this.error_order_lst[i].pro +
              " " +
              this.error_order_lst[i].city +
              " " +
              this.error_order_lst[i].dis +
              " " +
              this.error_order_lst[i].address
          );
        }
      } else {
        convenient_order_add.shop_id = this.error_order_lst[0].api_shop_id;
        for (var i = 0; i < this.error_order_lst.length; i++) {
          convenient_order_add.package.push(this.error_order_lst[i].order_no);
        }
      }
      localStorage.setItem("convenient_order_add", JSON.stringify(convenient_order_add));
      setTimeout(() => {
        this.$router.push("/order/add");
      }, 500);
    },
    onCopy(e) {
      // 复制成功
      this.$message({
        message: "复制成功！",
        type: "success",
      });
    },
    onError(e) {
      // 复制失败
      this.$message({
        message: "复制失败！",
        type: "error",
      });
    },
    onStatus(row) {},
    submitForm() {
      if (this.date) {
        var time1 = this.timeFilter13(new Date(this.date[0]).getTime());
        var time2 = this.timeFilter13(new Date(this.date[1]).getTime());
        this.param.createtime = time1 + " - " + time2;
      }
      this.param.page = 1;
      this.loadData();
    },
    resetForm(formName) {
      this.param = {
        page: 1,
        limit: 20,
        mode: "",
        status: "",
        mobile: "",
        order_no: "",
        express_no: "",
        out_order_no: "",
      };
      this.loadData();
    },
    // 切换状态
    handleClick(e) {
      this.tab_pane_active = e;
      const index = Number(e.index) - 1;
      this.param.status = index >= 0 ? index : "";
      this.loadData();
    },
    handleSizeChange(val) {
      this.param.limit = val;
      this.loadData();
    },
    // 分页
    handleCurrentChange(val) {
      this.param.page = val;
      this.loadData();
    },
    clickCopyBtn(text, event) {},

    loadData() {
      this.loadingData = true;
      if (this.out_order_no) {
        this.param.out_order_no = this.out_order_no;
      }
      apiOrderPacjAgeLst(this.param).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.rows;
          this.totalCount = res.data.total;
          this.loadingData = false;

          const new_status_list = [];
          for (const k in this.status_list) {
            const item = this.status_list[k];
            if (res.data.totalData[k]) {
              item.qty = res.data.totalData[k];
            } else {
              item.qty = 0;
            }
            new_status_list.push(item);
          }
          this.status_list = new_status_list;
        } else {
          this.$config.notifyMsg(res.msg, "error");
        }
      });
    },
    // 导出Excel
    exportBtn() {
      if (this.tableData.length <= 0) {
        this.$config.notifyMsg("暂无数据导出", "error");
        return false;
      }
      var url = "/api/export/orderList.html?out_order_no=" + this.out_order_no;
      if (this.param.status === 3) {
        url = url + "&status=" + this.param.status;
      }
      window.open(url);
    },
  },
};
</script>

<style>
.fzapp {
  font-size: 15px;
  color: white;
  text-align: center;
  line-height: 60px;
  width: 100%;
  height: 100%;
  float: left;
}
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #e4e4e4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.packagelst {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);

      .content {
        padding: 20px;

        .button-main {
          margin-bottom: 10px;
        }

        .filter-box {
          margin-bottom: 20px;

          .filter-item {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            & > div {
              display: flex;
              align-items: center;
              margin-right: 20px;
            }
          }

          .filter-item-key {
            width: 70px;
            color: #000;
            font-size: 14px;
            margin-right: 10px;
          }

          .btn {
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            margin-right: 10px;
            cursor: pointer;
            flex: none;
          }

          .btn1 {
            background-color: #0f375a;
            color: #ffffff;
            margin-left: 10px;
          }

          .btn2 {
            border: 1px solid #0f375a;
            color: #0f375a;
          }
        }

        .pages-box {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/packagelst.vue